import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../structure/Grid'
import { SmallText } from '../presentation/Text'
import Button from '../actions/Button'
import Separator from '../helpers/Separator'
import { getMappedErrors } from './_helpers/mappedErros'

const SubmitBar = ({ loading, error, label, onClick, children, mappedError, hideSubmit }) => {
  const { t } = useTranslation('common')
  return (
    <>
      <Separator weight={6} />
      <Grid justify="space-between" align="center" gutter={0.2}>
        <Col flex={1}>
          {error?.message && mappedError && (
            <SmallText color="red">
              {t('error')}: {mappedError && getMappedErrors(error.message)}
            </SmallText>
          )}
          {error?.message && !mappedError && (
            <SmallText color="red">
              {t('error')}: {error.message}
            </SmallText>
          )}
        </Col>

        <Col>{children}</Col>

        {!hideSubmit && (
          <Col>
            <Button type={!onClick && 'submit'} loading={loading} onClick={onClick}>
              {label || t('save')}
            </Button>
          </Col>
        )}
      </Grid>
    </>
  )
}

export default SubmitBar
